import { HTTP_STATUS } from '../constants';

/**
 * Thrown when login returns 403 because account is not activated.
 * UI should show activation code field and call activate endpoint.
 */
export class AccountNotActivatedError extends Error {
  constructor(message = 'Konto nie jest aktywowane. Wpisz kod z e-maila.') {
    super(message);
    this.name = 'AccountNotActivatedError';
    Object.setPrototypeOf(this, AccountNotActivatedError.prototype);
  }
}

/**
 * Parse error message from API response
 * @param response Fetch response object
 * @returns Error message string
 */
export async function parseErrorMessage(response: Response): Promise<string> {
  let errorMessage = `HTTP error! status: ${response.status}`;
  try {
    const errorData = await response.json();
    errorMessage = errorData.message || errorData.error || errorMessage;
  } catch (e) {
    try {
      const errorText = await response.text();
      if (errorText) {
        errorMessage = errorText;
      }
    } catch (textError) {
      // Ignore text parsing errors
    }
  }
  return errorMessage;
}

/**
 * Check if error is an authentication error
 * @param error Error object or string
 * @returns True if authentication error
 */
export function isAuthError(error: unknown): boolean {
  const errorMessage = error instanceof Error ? error.message : String(error);
  return (
    errorMessage.includes(String(HTTP_STATUS.UNAUTHORIZED)) ||
    errorMessage.includes(String(HTTP_STATUS.NOT_FOUND)) ||
    errorMessage.includes(String(HTTP_STATUS.INTERNAL_SERVER_ERROR)) ||
    errorMessage.includes('session expired') ||
    errorMessage.includes('no longer exists') ||
    errorMessage.includes('Unable to verify session') ||
    errorMessage.includes('Unauthorized') ||
    errorMessage.includes('No token available')
  );
}

